import { type ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';

interface LegalLayoutProps {
  source: string;
  children?: ReactNode;
}

export function LegalLayout({ source, children }: LegalLayoutProps) {
  return (
    <article className="legal-prose w-full max-w-2xl px-4 pb-12 sm:px-6">
      <ReactMarkdown>{source}</ReactMarkdown>
      {children}
    </article>
  );
}
